export default __webpack_public_path__ + "static/media/TIGER.d54abee3.gif";